import React from 'react';

export function Input({
  label,
  value,
  onChange,
  placeholder,
  type = 'text',
  error,
  helperText,
  icon: Icon,
  required = false,
  className = '',
  disabled = false,
  style = {},
  ...props
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', ...style }} className={className}>
      {label && (
        <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-main)', display: 'flex', alignItems: 'center', gap: '4px' }}>
          {label}
          {required && <span style={{ color: 'var(--accent-red)' }}>*</span>}
        </label>
      )}
      <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
        {Icon && (
          <div style={{ position: 'absolute', left: '12px', color: 'var(--text-dim)', pointerEvents: 'none', display: 'flex' }}>
            <Icon size={18} />
          </div>
        )}
        <input
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          style={{
            width: '100%',
            padding: Icon ? '11px 14px 11px 40px' : '11px 14px',
            background: 'var(--bg-input)',
            border: `1px solid ${error ? 'var(--accent-red)' : 'var(--border-color)'}`,
            borderRadius: 'var(--radius-md)',
            color: 'var(--text-main)',
            fontSize: '14px',
            outline: 'none',
            transition: 'border-color var(--transition-fast)',
            opacity: disabled ? 0.6 : 1
          }}
          onFocus={(e) => {
            if (!error) e.target.style.borderColor = 'var(--border-focus)';
          }}
          onBlur={(e) => {
            if (!error) e.target.style.borderColor = 'var(--border-color)';
          }}
          {...props}
        />
      </div>
      {error && <span style={{ fontSize: '12px', color: 'var(--accent-red)' }}>{error}</span>}
      {helperText && !error && <span style={{ fontSize: '12px', color: 'var(--text-dim)' }}>{helperText}</span>}
    </div>
  );
}

export function Textarea({
  label,
  value,
  onChange,
  placeholder,
  rows = 3,
  error,
  helperText,
  required = false,
  className = '',
  disabled = false,
  style = {},
  ...props
}) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', width: '100%', ...style }} className={className}>
      {label && (
        <label style={{ fontSize: '13px', fontWeight: 600, color: 'var(--text-main)', display: 'flex', alignItems: 'center', gap: '4px' }}>
          {label}
          {required && <span style={{ color: 'var(--accent-red)' }}>*</span>}
        </label>
      )}
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        rows={rows}
        disabled={disabled}
        style={{
          width: '100%',
          padding: '11px 14px',
          background: 'var(--bg-input)',
          border: `1px solid ${error ? 'var(--accent-red)' : 'var(--border-color)'}`,
          borderRadius: 'var(--radius-md)',
          color: 'var(--text-main)',
          fontSize: '14px',
          outline: 'none',
          resize: 'vertical',
          fontFamily: 'inherit',
          lineHeight: 1.5,
          transition: 'border-color var(--transition-fast)',
          opacity: disabled ? 0.6 : 1
        }}
        onFocus={(e) => {
          if (!error) e.target.style.borderColor = 'var(--border-focus)';
        }}
        onBlur={(e) => {
          if (!error) e.target.style.borderColor = 'var(--border-color)';
        }}
        {...props}
      />
      {error && <span style={{ fontSize: '12px', color: 'var(--accent-red)' }}>{error}</span>}
      {helperText && !error && <span style={{ fontSize: '12px', color: 'var(--text-dim)' }}>{helperText}</span>}
    </div>
  );
}

export default Input;
